import styled from 'styled-components';

export const Button = styled.button`
    height: 50px;
    width: 60%;
    background-color: #0b9f43;
    border-radius: 30px 30px 30px 30px;
    position: relative;
    color: white;
    font-family: 'League Spartan', sans-serif;
    font-size: x-large;
    border: 0px solid;
    cursor: pointer;
    &:hover {
        background-color: #076a2d;
    }
`;